<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <card>
                        <template slot="header">
                            <h4 class="card-title">Посты</h4>
                            <p class="card-category"></p>
                            <div class="row mt10">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Категория</label>
                                        <select v-model="categoryId" id="category-filter"
                                                @change="saveFilters('posts_category', categoryId)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option v-for="c in categories" v-bind:value="c.id">{{ c.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="status" id="status-filter"
                                                @change="saveFilters('posts_status', status)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option value="1">Активен</option>
                                            <option value="0">Не активен</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Формат</label>
                                        <select v-model="ratio" id="ratio-filter"
                                                @change="saveFilters('posts_ratio', ratio)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option value="1">4:5</option>
                                            <option value="2">4:3</option>
                                            <option value="3">9:16</option>
                                            <option value="4">1:1</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <fg-input type="text"
                                              label="Поиск по ID"
                                              v-model="filteredId"
                                              placeholder="">
                                    </fg-input>
                                </div>
                                <div class="col-md-2">
                                    <button type="submit" class="btn btn-info btn-fill"
                                            @click.prevent="filter">
                                        Фильтровать
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <button type="submit" class="btn btn-success btn-fill float-right"
                                            @click.prevent="add">
                                        Добавить
                                    </button>
                                </div>
                            </div>

                        </template>
                        <div class="table-responsive">
                            <table class="table" v-bind:class="{ 'loading-state': loading }">
                                <thead>
                                <slot name="columns">
                                    <th v-for="column in columns">
                                        <span v-if="column === 'sort'">сортировка</span>
                                        <span v-else-if="column === 'category'">категория</span>
                                        <span v-else-if="column === 'is_trendy'">тренд</span>
                                        <span v-else-if="column === 'ratio'">формат</span>
                                        <span v-else-if="column === 'preview_src_full'">обложка</span>
                                        <span v-else-if="column === 'status'">статус</span>
                                        <span v-else>{{column}}</span>
                                    </th>
                                </slot>
                                </thead>
                                <tbody>
                                <tr v-for="item in data">
                                    <slot :row="item">
                                        <td v-for="column in columns">
                                            <span v-if="column === 'translations'">{{ item[column] }}</span>
                                            <div v-else-if="column === 'preview_src_full'" @click="edit(item['id'])">
                                                <img :src="`${item[column]}`"
                                                     class="device-block device1"
                                                     :class="{
                                                         'device1-tall': item.ratio == 3,
                                                         'device1-wide': item.ratio == 2,
                                                         'device1-square': item.ratio == 4
                                                     }">
                                            </div>
                                            <span v-else-if="column === ''">
                                                <a class="text-primary" @click="edit(item['id'])">Изменить</a>
                                                <img class="new-tab" src="/static/img/new-tab.png" @click="openNewTab(item['id'])"/>
                                                <img class="new-tab" src="/static/img/copy.png" @click="duplicate(item['id'])"/>
                                              </span>
                                            <span v-else-if="column === 'status'">
                                                <span class="text-success" v-if="item[column] === 1">Активен</span>
                                                <span class="text-warning" v-if="item[column] === 0">Не активен</span>
                                              </span>
                                            <span v-else-if="column === 'is_trendy'">
                                                <span class="text-purple" v-if="item[column] === 1">Тренд</span>
                                              </span>
                                            <span v-else-if="column === 'ratio'">
                                                <span v-if="item[column] == 1">4:5</span>
                                                <span v-else-if="item[column] == 2">4:3</span>
                                                <span v-else-if="item[column] == 3">9:16</span>
                                                <span v-else-if="item[column] == 4">1:1</span>
                                                <span v-else>{{ item[column] }}</span>
                                              </span>
                                            <span v-else-if="column === 'category_id'">
                                                <span v-if="item[column] === 1">Пост</span>
                                                <span v-if="item[column] === 2">Карусель</span>
                                              </span>
                                            <span v-else>{{ item[column] }}</span>
                                        </td>
                                    </slot>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div :class="{ 'disabled' : data.length < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="next">
                            След.
                        </div>
                        <div :class="{ 'disabled' : offset < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="prev">
                            Пред.
                        </div>
                    </card>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";

const axios = require('axios')
import LTable from 'src/components/UIComponents/Table.vue'
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    components: {
        LTable,
        Card
    },
    created: function () {
        let self = this;

        let token = localStorage.getItem('token');

        axios.get(
            `${this.$hostname}/admin/posts/categories/`,
            {
                'params': {

                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                self.loading = false;
                self.categories = response.data;

                self.get();
            })
            .catch(function (error) {
                self.loading = false;
                console.log(error)
            });
    },
    data() {
        return {
            columns: ['id', 'category', 'ratio', 'is_trendy', 'preview_src_full', 'sort', 'status', ''],
            token: localStorage.getItem('token'),
            data: [],
            status: localStorage.getItem('posts_status') ? localStorage.getItem('posts_status') : "",
            categoryId: localStorage.getItem('posts_category') ? localStorage.getItem('posts_category') : "",
            ratio: localStorage.getItem('posts_ratio') ? localStorage.getItem('posts_ratio') : "",
            filteredId: null,
            categories: [],
            loading: false,
            limit: 30,
            offset: parseInt(localStorage.getItem('posts_active_offset')) || 0,
        }
    },
    computed: {
        graphicsUrl() {
            return this.$graphicsUrl
        },
    },
    methods: {
        init: function () {
            this.get()
        },
        filter: function () {
            localStorage.setItem('posts_active_offset', "0");
            this.offset = 0;

            this.get();
        },
        prev: function () {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('posts_active_offset', parseInt(this.offset));
            }
        },
        next: function () {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('posts_active_offset', parseInt(this.offset));
            }
        },
        add: function () {

            let self = this;

            axios.post(
                `${this.$hostname}/admin/posts/create`,
                null,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    self.$router.push({
                        name: 'edit-post',
                        params: {id: response.data.id}
                    });

                })
                .catch(function (error) {
                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });

        },
        duplicate: function (id) {

            let self = this;

            if (confirm(`Подтверждение дублирования карусели: ${id}`)) {
                axios.post(
                    `${this.$hostname}/admin/posts/duplicate`,
                    {id: id},
                    {
                        'headers': {
                            'Authorization': 'Bearer ' + this.token
                        }
                    })
                    .then(function (response) {

                        self.$router.push({
                            name: 'edit-post',
                            params: {id: response.data.id}
                        });

                    })
                    .catch(function (error) {
                        const notification = {
                            template: `<span><b>${error.response.data.message}</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-simple-remove',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })
                    });
            }



        },
        openNewTab: function (id) {
            if (this.role === 2) {
                return false;
            }
            const routeData = this.$router.resolve({
                name: 'edit-post',
                params: { id: id }
            });

            window.open(routeData.href, '_blank');
        },
        get: function () {
            let self = this;

            let token = localStorage.getItem('token');
            //this.loading = true;

            let filteredId = this.filteredId === null ? '' : this.filteredId;

            axios.get(
                `${this.$hostname}/admin/posts/`,
                {
                    'params': {
                        limit: self.limit,
                        offset: self.offset,
                        status: this.status,
                        categoryId: this.categoryId,
                        ratio: this.ratio,
                        filteredId: filteredId,
                    },
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    self.data = response.data;

                    self.loading = false;
                })
                .catch(function (error) {
                    self.loading = false;
                    console.log(error)
                })
        },
        edit: function (id) {
            this.$router.push({
                name: 'edit-post',
                params: {id: id}
            });
        },
        saveFilters: function(name, value) {
            localStorage.setItem(name, value);
        },
    },
    beforeRouteLeave (to, from , next) {
        if (to.path.indexOf('posts') < 1) {
            localStorage.setItem('posts_category', "");
            localStorage.setItem('posts_status', "");
            localStorage.setItem('posts_ratio', "");
            localStorage.setItem('posts_active_offset', "0");
        }
        next();
    },
}
</script>
<style scoped>
.pagination-button {
    height: 30px;
    padding: 1px 16px;
    margin-left: 20px;
    color: #fff !important;
}
.pagination-button.disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
.mt10 {
    margin-top: 10px;
}
.device1 {
    display: block;
    width: auto;
    height: auto;
    max-height: 90px;
    max-width: 30vw !important;
    object-fit: contain;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    background-color: transparent;
    border: 1px solid rgba(204, 204, 204, 0.5);
    border-radius: 8px;
}
.device1-tall {
    max-height: 152px;
}
.device1-wide {
    max-height: 69px;
}
.device1-square {
    max-height: 72px;
}
.no-color {
    width: 30px;
    margin-left: 20px;
}
img {
    max-width: 100% !important;
}
.btn-fill {
    margin-top: 25px;
}
.text-primary {
    cursor: pointer;
}
th {
    padding: 12px 8px;
}
.text-default {
    cursor: pointer;
    color: #000;
}
.text-success, .text-warning, .text-purple {
    font-weight: 700 !important;
}
.text-purple {
    color: #9368E9;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Posts.vue